<template>
  <div id="couponDetail" class="coupon-detail">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title" @click="toCouponList">优惠劵/</span>详情
      </template>
      <template v-slot:content>
        <section class="content base-info" ref="baseInfo">
          <div class="content-title">基础信息</div>
          <ul class="content-info">
            <li class="item">
              <span class="desc">优惠券名称：</span>{{ coupon.name }}
            </li>
            <li class="item">
              <span class="desc">有效时间：</span>
              <span
                class="range-time"
                v-if="coupon.timeType === timeTypes.rangeTime"
                >{{ coupon.beginTime }} 至 {{ coupon.endTime }}</span
              >
              <span class="effective-time" v-else
                >领取后{{ coupon.effectiveTime }}天内有效</span
              >
            </li>
            <li class="item">
              <span class="desc">优惠券面值：</span>{{ coupon.faceValue }}元
            </li>
            <li class="item" v-if="coupon.baseMoney">
              <span class="desc">使用条件：</span>满{{ coupon.baseMoney }}元可用
            </li>
            <li class="item" v-else>
              <span class="desc">使用条件：</span>无限制
            </li>
            <li class="item">
              <span class="desc">使用说明：</span>{{ coupon.instruction }}
            </li>
          </ul>
        </section>
        <section class="content assign-setting">
          <div class="content-title">发放设置</div>
          <div class="content-info">
            <li class="item">
              <span class="desc">发放方式：</span>
              <span class="assign-method">{{ coupon.assignMethodDesc }}</span>
            </li>
            <li
              class="item"
              v-if="coupon.assignMethod === assignMethodMap.proactive"
            >
              <span class="desc">总共发放：</span>{{ coupon.totalNum }}张
            </li>
            <li
              class="item"
              v-if="coupon.assignMethod === assignMethodMap.proactive"
            >
              <span class="desc">每人限领：</span>{{ coupon.perPeopleLimit }}张
            </li>
          </div>
        </section>
        <section class="content coupon-use-range">
          <div class="content-title">商品设置</div>
          <ul class="content-info use-range-info">
            <li class="item"><span class="desc">商品范围：</span></li>
            <li
              class="all-good"
              v-show="coupon.useRangeType === useRangeTypes.allGood"
            >
              全部商品
            </li>
            <li
              class="classifies"
              v-show="coupon.useRangeType === useRangeTypes.specialClassify"
            >
              指定分类({{ classifyDesc }})
            </li>
            <li
              class="goods"
              v-show="coupon.useRangeType === useRangeTypes.specialGood"
            >
              指定商品
            </li>
          </ul>
          <div
            class="out-container"
            v-show="coupon.useRangeType === useRangeTypes.specialGood"
          >
            <div class="table-img designated-goods">
              <el-table class="table-container" :data="specialGoodList">
                <el-table-column label="图片" width="200">
                  <template slot-scope="props">
                    <div class="img-container">
                      <img class="good-img" :src="props.row.img" alt="商品图" />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="商品名称" prop="name"></el-table-column>
                <el-table-column
                  label="商品编号"
                  prop="numCode"
                ></el-table-column>
              </el-table>
            </div>
            <div class="pagination-tpl-container">
              <pagination-tpl
                :total="goodTotal"
                :pageSize="10"
                @queryChange="searchGood"
              ></pagination-tpl>
            </div>
          </div>
        </section>
        <section class="content customer-info">
          <div class="content-title">发放客户</div>
          <div class="out-container">
            <div class="out-container-search">
              <el-input
                class="gray"
                placeholder="请输入客户名称"
                v-model="customerName"
                @keyup.enter.native="searchCustomerName"
              >
                <i slot="suffix" class="el-input__icon el-icon-search" @click="searchCustomerName"></i>
              </el-input>
            </div>
            <div class="table">
              <el-table class="table-container" :data="customerList">
                <el-table-column label="客户名称" prop="name"></el-table-column>
                <el-table-column
                  label="用户名"
                  prop="username"
                ></el-table-column>
                <el-table-column
                  label="已领取"
                  prop="receivedNum"
                ></el-table-column>
                <el-table-column
                  label="可使用"
                  prop="countUsable"
                ></el-table-column>
                <el-table-column
                  label="已使用"
                  prop="usedNum"
                ></el-table-column>
                <el-table-column label="操作" v-if="coupon.assignMethod == 2">
                  <template slot-scope="props">
                    <el-button
                      class="btn-text"
                      type="text"
                      @click="withdraw(props.row)"
                      >撤回</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pagination-tpl-container">
              <pagination-tpl
                :total="customerTotal"
                @queryChange="searchCustomer"
              ></pagination-tpl>
            </div>
          </div>
        </section>
        <div class="operations" ref="operations">
          <el-button class="btn-white" @click="toCouponList">返回</el-button>
          <el-button
            class="btn-blue"
            v-if="showAssignBtn"
            @click="toAssignCoupon"
            >发放</el-button
          >
        </div>
      </template>
    </second-menu-link-content>
    <!-- 撤回 -->
    <el-dialog
      class="withdraw"
      title="撤回"
      :visible.sync="withdrawDialog"
      :before-close="handleClose"
    >
      <p>请确认撤回未使用优惠券的数量</p>
      <div class="nums">
        <span>数量：</span>
        <span class="nums-input">
          <el-input
            v-model="nums"
            class="gray"
            placeholder="请输入数量"
            @input="inputUnitPrice(nums)"
          >
          </el-input>
        </span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-white" @click="handleClose">取消</el-button>
        <el-button class="btn-blue" @click="confirmDelivery">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { formatTimeToDate } from "common/js/util.js";
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationTpl from "base/PaginationTpl";
import DBCoupon from "models/db/coupon";
const dbCoupon = new DBCoupon();
const timeTypes = {
  rangeTime: 1,
  effectiveTime: 2,
};
const assignMethodMap = {
  proactive: 1,
  passive: 2,
};
const assignDescList = {
  1: "主动领取",
  2: "定向发放",
};
// 优惠券处于已启用状态
const IS_PROCESSING = 200;
const useRangeTypes = {
  allGood: 1,
  specialClassify: 2,
  specialGood: 3,
};
export default {
  data() {
    return {
      timeTypes,
      useRangeTypes,
      assignMethodMap,
      withdrawDialog: false,
      nums: null,
      customerName: '',
      // 优惠券相关信息
      coupon: {
        name: "",
        timeType: "",
        beginTime: "",
        endTime: "",
        effectiveTime: 0,
        faceValue: 0,
        baseMoney: 0,
        instruction: "",
        assignMethod: "",
        assignMethodDesc: "",
        totalNum: 0,
        perPeopleLimit: 0,
        // 1 -- 全部商品 2 -- 指定分类 3 -- 指定商品
        useRangeType: "",
        status,
      },
      cusId: null,   // 选择的客户id
      // 指定分类
      classifies: [],
      // 商品总数
      goodTotal: 0,
      // 指定商品列表
      specialGoodList: [],
      // 客户总条数
      customerTotal: 0,
      // 已分发的客户
      customerList: [],
    };
  },
  computed: {
    showAssignBtn() {
      return (
        this.coupon.assignMethod === assignMethodMap.passive &&
        this.coupon.status === IS_PROCESSING
      );
    },
    classifyDesc() {
      let desc = "";
      this.classifies.map((item, index) => {
        if (index !== this.classifies.length - 1) {
          desc += item.name + ",";
        } else {
          desc += item.name;
        }
      });
      return desc;
    },
  },
  methods: {
    /* 限制数量为整数 */
    inputUnitPrice(val) {
      let price = val.toString().match(/^(\+)?\d*/g)
        ? val === "00"
          ? "0"
          : val.toString().match(/^(\+)?\d*/g)[0]
        : "";
      this.nums = price
    },
    searchCustomerName() {
      this._getCustomerListWithCoupon({
        id: this.$route.query.id,
        currentPage: 1,
        cusName: this.customerName,
      });
    },
    // 客户翻页
    searchCustomer(query) {
      // console.log('客户翻页', query);
      this._getCustomerListWithCoupon({
        id: this.$route.query.id,
        currentPage: query.currentPage,
        cusName: this.customerName,
      });
    },
    // 商品翻页
    searchGood(query) {
      // console.log('商品翻页', query)
      this._getGoodListWithCoupon({
        id: this.$route.query.id,
        currentPage: query.currentPage,
      });
    },
    toCouponList() {
      this.$router.push({
        path: "/admin/marketing/coupon/coupon-list",
      });
    },
    toAssignCoupon() {
      this.$router.push({
        path: "/admin/marketing/coupon/assign-coupon",
        query: {
          couponId: this.$route.query.id,
        },
      });
    },
    _getCouponDetail(couponId) {
      dbCoupon.getCouponDetail(couponId).then((res) => {
        if (res.success) {
          // console.log('优惠券相关信息', res.result);
          let { coupon } = res.result;
          // console.log('优惠券详情', coupon);
          let {
            title,
            timeType,
            beginTime,
            endTime,
            effectiveTime,
            faceValue,
            baseMoney,
            instruction,
            goodsLimit,
            cateScope,
            issuanceMethod,
            num,
            receivedLimit,
            status,
          } = coupon;
          this.coupon.status = status;
          this.coupon.name = title;
          this.coupon.timeType = timeType;
          this.coupon.beginTime = formatTimeToDate(beginTime);
          this.coupon.endTime = formatTimeToDate(endTime);
          this.coupon.effectiveTime = effectiveTime;
          this.coupon.faceValue = faceValue;
          this.coupon.baseMoney = baseMoney;
          this.coupon.instruction = instruction;
          // 优惠券适用范围 1--全部商品 2--指定分类 3--指定商品
          this.coupon.useRangeType = goodsLimit;
          this.coupon.assignMethod = issuanceMethod;
          this.coupon.assignMethodDesc = assignDescList[issuanceMethod];
          this.coupon.totalNum = num;
          this.coupon.perPeopleLimit = receivedLimit;
          // 如果是指定商品，那么要填充商品列表
          if (goodsLimit === useRangeTypes.specialGood) {
            // 要获取商品列表
            this.specialGoodList = [];
            this._getGoodListWithCoupon({
              id: this.$route.query.id,
              currentPage: 1,
            });
          }
          // 填充分类
          console.log("商品分类--", cateScope);
          if (goodsLimit === useRangeTypes.specialClassify) {
            this.classifies = cateScope;
          }
          // 获取已发放的客户列表
          this._getCustomerListWithCoupon({
            id: this.$route.query.id,
            currentPage: 1,
            cusName: this.customerName,
          });
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    _getCustomerListWithCoupon(options) {
      dbCoupon.getCustomerListWithCoupon(options).then((res) => {
        if (res.success) {
          let { totalNum, items } = res.result;
          this.customerTotal = totalNum;
          this.customerList = [];
          items.map((customer) => {
            this.customerList.push({
              name: customer.cusName,
              username: customer.userName,
              receivedNum: customer.countReceive,
              countUsable: customer.countUsable,
              cusId: customer.cusId,
              usedNum: customer.countUsd,
            });
          });
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    _getGoodListWithCoupon(options) {
      dbCoupon.getGoodListWithCoupon(options).then((res) => {
        if (res.success) {
          // 商品列表
          let { totalNum, items } = res.result;
          console.log("商品列表", items);
          this.goodTotal = totalNum;
          this.specialGoodList = [];
          items.map((good) => {
            this.specialGoodList.push({
              img: good.goodsPic,
              name: good.name,
              numCode: good.goodsCode,
            });
          });
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    withdraw(row) {
      this.cusId = row.cusId
      this.withdrawDialog = true
    },
    handleClose() {
      this.withdrawDialog = false
    },
    confirmDelivery() {
      let count = this.nums
      let cusId = this.cusId
      let couponId = this.$route.query.id
      let data = {
        count,
        cusId,
        couponId
      }
      dbCoupon.postWithdraw(data).then(res => {
        if (res.success) {
          // 获取已发放的客户列表
          this._getCustomerListWithCoupon({
            id: this.$route.query.id,
            currentPage: 1,
            cusName: this.customerName,
          });
          this.handleClose()
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      })
    }
  },
  created() {
    const couponId = this.$route.query.id;
    this._getCouponDetail(couponId);
  },
  mounted() {
    const paddingWidth = 46;
    this.$refs.operations.style.width =
      this.$refs.baseInfo.clientWidth + paddingWidth + "px";
    window.onresize = () => {
      this.$refs.operations.style.width =
        this.$refs.baseInfo.clientWidth + paddingWidth + "px";
    };
  },
  components: {
    SecondMenuLinkContent,
    PaginationTpl,
  },
};
</script>

<style lang="scss" scoped>
.coupon-detail {
  width: 100%;
  height: 100%;
  font-size: 14px;
  color: rgba(96, 98, 102, 1);
  .title {
    color: rgba(61, 116, 242, 0.75);
    cursor: pointer;
    &:hover {
      color: rgba(61, 116, 242, 1);
    }
  }
  .content {
    box-sizing: border-box;
    margin-top: 20px;
    .content-title {
      box-sizing: border-box;
      width: 100%;
      height: 32px;
      padding-left: 6px;
      line-height: 32px;
      font-size: 16px;
      font-weight: 550;
      color: #333333;
      margin-bottom: 16px;
      background: rgba(245, 247, 250, 1);
      border-radius: 4px 4px 0px 0px;
    }
    .content-info {
      .item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 14px;
        margin-bottom: 16px;
        .desc {
          width: 120px;
          text-align: right;
        }
      }
    }
    .use-range-info {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 16px;
      .item {
        margin-bottom: 0px;
      }
    }
    .out-container {
      padding-left: 40px;
      margin-bottom: 16px;
      .pagination-tpl-container {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }
    .designated-goods {
      .img-container {
        .good-img {
          width: 40px;
          height: 40px;
        }
      }
    }
  }
  .customer-info {
    .out-container {
      padding-bottom: 26px;
    }
  }
  .operations {
    height: 60px;
    position: fixed;
    left: 256px;
    bottom: 0;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 6px 0px rgba(219, 223, 230, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99;
    .btn-white {
      margin-right: 20px;
    }
  }
  .out-container-search {
    width: 280px;
    float: right;
    margin-bottom: 16px;
  }
}
</style>
<style lang="scss">
.coupon-detail {
  .withdraw {
    .el-dialog {
      width: 420px;
      margin-top: 32vh !important;
    }
    .el-dialog__header {
      border-bottom: 1px solid #eee;
      line-height: 38px;
      .el-dialog__title {
        font-size: 16px;
        font-weight: bold;
        color: #666666;
      }
      .el-dialog__headerbtn {
        top: 10px;
      }
    }
    .el-dialog__body {
      border-bottom: 1px solid #eee;
      padding: 20px 45px 20px 32px;
      p {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        margin-bottom: 20px;
      }
      .nums {
        display: flex;
        align-items: center;
        .nums-input {
          flex: 1;
        }
      }
    }
    .el-dialog__footer {
      height: 72px;
      padding: 20px;
      text-align: center;
    }
  }
}
</style>
